<template>
  <div class="bind">
    <div class="bind-box" v-if="isSuccess == 1">
      <van-icon class="bind-icon" name="warning" />
      您确定登录吗？
      <van-button
        style="margin:50px 0 20px;"
        type="primary"
        block
        @click="handleLog"
        >登录</van-button
      >
      <van-button type="default" plain hairline block @click="cancel"
        >取消登录</van-button
      >
    </div>
    <div class="bind-box passed-box" v-else-if="isSuccess == 2">
      <van-icon class="bind-icon" name="passed" />
      登陆成功
    </div>
    <div class="bind-box warning-box" v-else-if="isSuccess == 3">
      <van-icon class="bind-icon" name="warning-o" />
      {{ errorMsg }}
      <img
        class="bind-img"
        v-if="isUnBind"
        src="@/assets/images/bind_img.png"
      />
    </div>
  </div>
</template>

<script>
import { Button, Icon, Dialog } from "vant";
import { mapActions } from "vuex";
import LoginAdminApi from "@/api/loginAdmin";
export default {
  name: "bindWechat",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      urlParams: {},
      isSuccess: 1,
      show: false,
      errorMsg: "",
      isUnBind: false,
    };
  },
  created() {
    const urlParams = this.$route.query;
    const code = urlParams.code;
    if (code) {
      this.handleLog();
    }
  },
  methods: {
    ...mapActions(["setUserInfo"]),
    getParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const url = decodeURIComponent(window.location.search);
      if (url.indexOf("?") != -1) {
        const param = url.substr(1);
        if (param) {
          var r = param.trim().match(reg); //获取url中"?"符后的字符串并正则匹配
          if (r != null) {
            return decodeURIComponent(r[2]);
          } else {
            return "";
          }
        }
      } else {
        return "";
      }
    },
    handleLog() {
      const query = this.$route.query;
      const code = query.code;
      let url = window.location.href;
      const keyId = query.KeyId ? query.KeyId : this.getParam("KeyId");

      if (versionConfig.ZHIYUN_VERSION && versionConfig.WECHAT_AUTHORURL) {
        url =
          versionConfig.WECHAT_AUTHORURL +
          window.location.pathname +
          window.location.search;
      }
      if (!code) {
        LoginAdminApi.GetRedirectUrlForLoginAdmin({
          ReturnUrl: url,
          OpenId: query.OpenId,
        })
          .then(res => {
            window.location.href = res.Data;
          })
          .catch(err => {
            console.error(err, "err:getRedirectFullUrl");
          });
      } else {
        LoginAdminApi.VerifyOpenIdForLoginAdmin({
          Code: code,
          Key: keyId,
          OpenId: query.OpenId,
          CompanyCode: query.CompanyCode,
          IsZYPlus: versionConfig.ZHIYUN_VERSION,
        }).then(res => {
          // const json = {
          //   ...res.Data,
          //   ...res.Data.Token
          // };
          // this.setUserInfo(json);
          // this.$router.push({
          //   name: "index"
          // });
          if (res.Data && res.Data.UserId != "0") {
            this.isSuccess = 2;
          } else {
            // Dialog.alert({
            //   message: "请先去系统中绑定微信号"
            // }).then(() => {
            //    this.isSuccess = 3;
            //   this.errorMsg="未绑定微信号，请先去系统中绑定微信号";
            // });
            this.isSuccess = 3;
            this.errorMsg =
              "未绑定微信号，请登录系统后点击右上角的用户姓名，在微信设置中绑定微信";
            this.isUnBind = true;
          }
        });
      }
    },
    cancel() {
      this.isSuccess = 3;
      this.isUnBind = false;
      this.errorMsg = "您已取消登录";
    },
  },
};
</script>

<style lang="less" scoped>
.bind-box {
  margin-top: 50px;
  font-size: 18px;
  text-align: center;
  width: 80%;
  margin-left: 10%;
  .bind-icon {
    font-size: 100px;
    display: block;
    color: #44b549;
    margin-bottom: 15px;
  }
}
.passed-box {
  margin-top: 100px;
  font-size: 22px;
  color: #0aa510;
  .bind-icon {
    font-size: 140px;
  }
}
.warning-box {
  margin-top: 100px;
  font-size: 22px;
  color: #ff9e00;
  .bind-icon {
    font-size: 140px;
    color: #ff9e00;
  }
}
.bind-img {
  width: 300px;
  display: block;
  margin: 30px auto;
}
</style>
